import React from "react";
import WeatherInfo from "./weather-info";

export default WeatherInfo;
